<template>
  <div class="dash-root">
    <div id="layout-wrapper">

      <!-- ========== TOP BAR ========== -->
      <nav class="dash-topbar">
        <div class="container d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center" style="gap:16px;">
            <a href="javascript:void(0)" @click="$router.push('/')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
            <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">Dashboard</span>
          </div>
          <div class="d-flex align-items-center" style="gap:14px;">
            <a href="javascript:void(0)" @click="$router.push('/marketplace')" style="color:var(--fm-m,#A09888);font-size:13px;text-decoration:none;"><i class="mdi mdi-storefront-outline me-1"></i>Marketplace</a>
            <a href="javascript:void(0)" @click="$router.push('/farm')" style="color:var(--fm-m,#A09888);font-size:13px;text-decoration:none;"><i class="mdi mdi-barn me-1"></i>My Farm</a>
            <a v-if="isAdmin" href="javascript:void(0)" @click="$router.push('/admin')" style="color:#BFA164;font-size:13px;text-decoration:none;" title="Admin Console"><i class="mdi mdi-shield-crown me-1"></i>Admin</a>
            <div class="dash-icon-btn" @click="$router.push('/messages')" title="Messages">
              <i class="mdi mdi-message-text-outline" style="font-size:20px;"></i>
            </div>
            <div class="dash-icon-btn" @click="$router.push('/notifications')" title="Notifications" style="position:relative;">
              <i class="mdi mdi-bell-outline" style="font-size:20px;"></i>
              <span v-if="unreadCount > 0" class="dash-notif-badge">{{ unreadCount }}</span>
            </div>
            <div class="dash-user-btn" @click="showUserMenu=!showUserMenu">
              <user-avatar :src="user.avatar_url" :name="user.display_name" size="sm" />
            </div>
          </div>
        </div>
      </nav>

      <!-- User Menu Dropdown -->
      <div v-if="showUserMenu" class="dash-user-menu" @click.self="showUserMenu=false">
        <div class="dash-menu-card">
          <div class="d-flex align-items-center gap-3 mb-3 pb-3" style="border-bottom:1px solid var(--fm-br);">
            <user-avatar :src="user.avatar_url" :name="user.display_name" size="lg" />
            <div>
              <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);">{{ user.display_name }}</div>
              <div style="color:var(--fm-s,#6B6356);font-size:12px;">{{ user.phone }}</div>
            </div>
          </div>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/me');showUserMenu=false"><i class="mdi mdi-account-edit me-2"></i>My Profile</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/my-listings');showUserMenu=false"><i class="mdi mdi-tag-multiple me-2"></i>My Listings</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/sell/products');showUserMenu=false"><i class="mdi mdi-package-variant me-2"></i>My Products (Agro-Inputs)</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/my-offers');showUserMenu=false"><i class="mdi mdi-handshake me-2"></i>My Offers</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/marketplace/saved');showUserMenu=false"><i class="mdi mdi-heart me-2"></i>Saved</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/my-buy-requests');showUserMenu=false"><i class="mdi mdi-bullhorn me-2"></i>Buy Requests</a>
          <a href="javascript:void(0)" class="dash-menu-item" @click="$router.push('/marketplace/suppliers');showUserMenu=false"><i class="mdi mdi-account-group me-2"></i>Suppliers</a>
          <a href="javascript:void(0)" class="dash-menu-item" style="color:#50C878;" @click="$router.push('/farm');showUserMenu=false"><i class="mdi mdi-barn me-2"></i>My Farm</a>
          <a href="javascript:void(0)" class="dash-menu-item" style="color:#50C878;" @click="$router.push('/verification');showUserMenu=false"><i class="mdi mdi-shield-check me-2"></i>Get Verified</a>
          <a v-if="isAdmin" href="javascript:void(0)" class="dash-menu-item" style="color:#BFA164;" @click="$router.push('/admin');showUserMenu=false"><i class="mdi mdi-shield-crown me-2"></i>Admin Console</a>
          <div style="border-top:1px solid var(--fm-br,#1E1E1E);margin-top:8px;padding-top:8px;">
            <a href="javascript:void(0)" class="dash-menu-item" style="color:#FF6B6B;" @click="logout"><i class="mdi mdi-logout me-2"></i>Sign Out</a>
          </div>
        </div>
      </div>

      <!-- ========== CONTENT ========== -->
      <div class="container dash-container">

        <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

        <div v-else>
          <!-- Welcome -->
          <div class="dash-welcome mb-4">
            <div>
              <h4 class="fw-bold mb-1" style="color:var(--fm-h,#F5F0E8);">{{ greeting }}, {{ firstName }}!</h4>
              <p style="color:var(--fm-s,#6B6356);font-size:13px;margin:0;">Here's what's happening on your Flockr account.</p>
            </div>
            <button class="btn btn-warning d-none d-md-block" @click="$router.push('/sell/create')">
              <i class="mdi mdi-plus me-1"></i> New Listing
            </button>
          </div>

          <!-- Stats Row -->
          <div class="row g-3 mb-4">
            <div class="col-6 col-md-3" v-for="stat in statsCards" :key="stat.label">
              <div class="dash-stat-card" @click="stat.route ? $router.push(stat.route) : null" :style="stat.route ? 'cursor:pointer' : ''">
                <i :class="stat.icon" :style="'font-size:22px;color:' + stat.color"></i>
                <div class="dash-stat-val">{{ stat.value }}</div>
                <div class="dash-stat-lbl">{{ stat.label }}</div>
              </div>
            </div>
          </div>

          <!-- Quick Actions -->
          <div class="row g-3 mb-4">
            <div class="col-6 col-md-3" v-for="(qa,qi) in quickActions" :key="'qa-'+qi">
              <div class="dash-quick-card" @click="$router.push(qa.route)">
                <i :class="qa.icon" style="font-size:24px;color:#BFA164;"></i>
                <div class="dash-quick-label">{{ qa.label }}</div>
              </div>
            </div>
          </div>

          <!-- Vet Services Banner -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/vet/dashboard')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;" :style="{background:isVet?'rgba(80,200,120,.1)':'rgba(191,161,100,.08)',color:isVet?'#50C878':'#BFA164'}">🩺</div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">{{ isVet ? 'Vet Dashboard' : 'Offer Vet Services' }}</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ isVet ? 'Manage appointments, earnings & profile' : 'Register as a vet to receive bookings from farmers' }}</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Transport Banner — always visible, routes based on role -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/my-transports')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(241,180,76,.12);color:#f1b44c;">🚛</div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">My Transport Bookings</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">Track requested transports, follow live trip status, view past deliveries</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Cart Banner — shows badge when items present -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/cart')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(191,161,100,.12);color:#BFA164;position:relative;">
                <i class="mdi mdi-cart"></i>
                <span v-if="cartCount" style="position:absolute;top:-4px;right:-4px;background:#FF6B6B;color:#fff;border-radius:10px;padding:1px 6px;font-size:10px;font-weight:700;min-width:18px;text-align:center;">{{ cartCount }}</span>
              </div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">My Cart</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ cartCount ? cartCount + ' item' + (cartCount===1?'':'s') + ' ready to checkout' : 'Add animals or products from the marketplace' }}</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Agro-Input Shop Banner -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/shop')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(241,196,15,.12);color:#f1c40f;">📦</div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">Agro-Input Shop</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">Feeds, supplements, vet drugs, equipment — delivered or pick up</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Community & Learning Banner -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/learn')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(155,89,182,.12);color:#9b59b6;">📚</div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">Community &amp; Learning</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">Read farmer guides, ask the forum, get vet-verified answers</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Market Intelligence Banner -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/market')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(79,195,247,.12);color:#4FC3F7;">📈</div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">Market Intelligence</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">Weekly livestock prices per county + market reports — know what your animals are worth</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- Insurance Banner — protect the herd -->
          <div class="dash-card mb-4 d-flex align-items-center justify-content-between" style="cursor:pointer;" @click="$router.push('/insurance')">
            <div class="d-flex align-items-center gap-3">
              <div style="width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;background:rgba(80,200,120,.12);color:#50C878;">🛡️</div>
              <div>
                <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">Livestock Insurance</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">Cover your animals against drought, disease, accident and theft — KLIP, APA, UAP, Jubilee</div>
              </div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:var(--fm-s,#6B6356);font-size:20px;"></i>
          </div>

          <!-- WORKER TASKS — shows for anyone with assigned tasks -->
          <div v-if="workerFarms.length||workerTasks.length" class="dash-card mb-4">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h6 class="fw-bold mb-0" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-clipboard-list me-2" style="color:#BFA164;"></i>My Tasks</h6>
              <div class="d-flex gap-2 align-items-center">
                <span v-if="workerStats.overdueTasks" style="background:#c62828;color:#fff;font-size:10px;padding:2px 8px;border-radius:10px;font-weight:600;">{{ workerStats.overdueTasks }} overdue</span>
                <span style="color:var(--fm-s,#6B6356);font-size:12px;">{{ workerStats.pendingTasks }} pending</span>
              </div>
            </div>

            <!-- Farm chips -->
            <div v-if="workerFarms.length" class="d-flex gap-2 flex-wrap mb-3">
              <div v-for="wf in workerFarms" :key="wf.farm_id" class="d-flex align-items-center gap-2" style="background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:6px 10px;cursor:pointer;" @click="$router.push('/farm')">
                <i class="mdi mdi-barn" style="color:#BFA164;"></i>
                <div><div style="color:var(--fm-h,#F5F0E8);font-size:12px;font-weight:600;">{{ wf.farm_name }}</div><div style="color:var(--fm-s,#6B6356);font-size:10px;text-transform:capitalize;">{{ wf.role }}</div></div>
              </div>
            </div>

            <!-- Task list -->
            <div v-for="wt in workerTasks" :key="'wt-'+wt.id" style="background:var(--fm-bg2,#0F0F0F);border:1px solid #1A1A1A;border-radius:10px;padding:12px;margin-bottom:8px;">
              <div class="d-flex justify-content-between align-items-start">
                <div class="flex-fill">
                  <div class="d-flex align-items-center gap-2 flex-wrap">
                    <strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ wt.title }}</strong>
                    <span class="dash-status-dot" :class="'st-'+wt.status">{{ (wt.status||'').replace(/_/g,' ') }}</span>
                    <span :style="{color:wt.priority==='high'?'#FF6B6B':wt.priority==='medium'?'#FF9800':'#6B6356',fontSize:'10px',fontWeight:600}">{{ wt.priority }}</span>
                  </div>
                  <div v-if="wt.description" style="color:var(--fm-s,#6B6356);font-size:12px;margin-top:3px;">{{ wt.description }}</div>
                  <div style="color:var(--fm-m,#A09888);font-size:11px;margin-top:4px;">
                    <i class="mdi mdi-barn me-1"></i>{{ wt.farm_name }}
                    <span class="ms-2"><i class="mdi mdi-calendar me-1"></i>{{ fDate(wt.due_date) }}</span>
                    <span v-if="wt.due_time" class="ms-1">{{ formatTime(wt.due_time) }}</span>
                    <span v-if="wt.animal_name" class="ms-2"><i class="mdi mdi-cow me-1"></i>{{ wt.animal_name }}</span>
                  </div>
                  <div v-if="wt.require_photo==='1'||wt.require_gps==='1'||wt.require_notes==='1'" style="margin-top:4px;display:flex;gap:4px;flex-wrap:wrap;">
                    <span v-if="wt.require_photo==='1'" style="font-size:9px;color:#4FC3F7;background:var(--fm-bg3,#0F2030);padding:1px 5px;border-radius:3px;">📷 Photo</span>
                    <span v-if="wt.require_gps==='1'" style="font-size:9px;color:#FF6B6B;background:var(--fm-bg3,#200F0F);padding:1px 5px;border-radius:3px;">📍 GPS</span>
                    <span v-if="wt.require_notes==='1'" style="font-size:9px;color:#BFA164;background:var(--fm-bg3,#1a1510);padding:1px 5px;border-radius:3px;">📝 Notes</span>
                  </div>
                </div>
                <div class="d-flex gap-1 flex-shrink-0 ms-2">
                  <button v-if="wt.status==='pending'" class="btn btn-sm btn-outline-info" @click="workerStartTask(wt)" title="Start"><i class="mdi mdi-play"></i></button>
                  <button v-if="wt.status==='in_progress'&&workerTaskNeedsEvidence(wt)" class="btn btn-sm btn-outline-success" @click="workerCompleteWithEvidence(wt)" title="Complete with evidence"><i class="mdi mdi-camera-plus"></i></button>
                  <button v-if="wt.status==='in_progress'&&!workerTaskNeedsEvidence(wt)" class="btn btn-sm btn-outline-success" @click="workerCompleteTask(wt)" title="Complete"><i class="mdi mdi-check"></i></button>
                </div>
              </div>
            </div>

            <div v-if="workerTasks.length===0" style="color:var(--fm-s,#6B6356);font-size:12px;text-align:center;padding:16px;">
              <i class="mdi mdi-check-circle" style="font-size:24px;color:#50C878;display:block;margin-bottom:4px;"></i>
              All tasks completed! Great work.
            </div>

            <div v-if="workerCompleted.length" style="margin-top:12px;">
              <div style="color:var(--fm-s,#6B6356);font-size:11px;font-weight:600;margin-bottom:6px;">Recently Completed ({{ workerCompleted.length }})</div>
              <div v-for="wc in workerCompleted.slice(0,5)" :key="'wc-'+wc.id" class="d-flex align-items-center gap-2 py-1" style="border-bottom:1px solid var(--fm-br);">
                <i class="mdi mdi-check-circle" style="color:#50C878;font-size:14px;"></i>
                <span style="color:var(--fm-m,#A09888);font-size:12px;flex:1;">{{ wc.title }}</span>
                <span style="color:var(--fm-s,#6B6356);font-size:10px;">{{ wc.farm_name }}</span>
              </div>
            </div>
          </div>

          <div class="row g-4">
            <!-- Recent Listings -->
            <div class="col-lg-6">
              <div class="dash-card">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="fw-bold mb-0" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-tag-multiple me-2"></i>My Listings</h6>
                  <a href="javascript:void(0)" @click="$router.push('/my-listings')" style="color:#BFA164;font-size:12px;text-decoration:none;">View All</a>
                </div>
                <div v-if="recentListings.length === 0" class="text-center py-3">
                  <p style="color:var(--fm-s,#6B6356);font-size:13px;">No listings yet</p>
                  <button class="btn btn-sm btn-warning" @click="$router.push('/sell/create')"><i class="mdi mdi-plus me-1"></i>Create</button>
                </div>
                <div v-else>
                  <div v-for="(l,li) in recentListings.slice(0,5)" :key="'l-'+li" class="dash-list-item" @click="$router.push('/marketplace/listing/'+l.id)">
                    <div class="dash-list-thumb">
                      <img v-if="l.primary_photo" :src="photoUrl(l.primary_photo)" />
                      <i v-else class="mdi mdi-paw" style="font-size:16px;color:#BFA164;"></i>
                    </div>
                    <div class="flex-fill">
                      <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ l.title }}</div>
                      <div style="color:#BFA164;font-size:12px;font-weight:600;">KES {{ formatPrice(l.price) }}</div>
                    </div>
                    <span class="dash-status-dot" :class="'st-'+l.status">{{ l.status }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Recent Offers -->
            <div class="col-lg-6">
              <div class="dash-card">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="fw-bold mb-0" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-handshake me-2"></i>Recent Offers</h6>
                  <a href="javascript:void(0)" @click="$router.push('/my-offers')" style="color:#BFA164;font-size:12px;text-decoration:none;">View All</a>
                </div>
                <div v-if="recentOffers.length === 0" class="text-center py-3"><p style="color:var(--fm-s,#6B6356);font-size:13px;">No offers received yet</p></div>
                <div v-else>
                  <div v-for="(o,oi) in recentOffers.slice(0,5)" :key="'o-'+oi" class="dash-list-item">
                    <div class="dash-avatar-xs">{{ getInitials(o.buyer_name) }}</div>
                    <div class="flex-fill">
                      <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ o.buyer_name }}</div>
                      <div style="color:#BFA164;font-size:12px;font-weight:600;">KES {{ formatPrice(o.offered_price) }}</div>
                      <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ o.listing_title }}</div>
                    </div>
                    <span class="dash-status-dot" :class="'st-'+o.status">{{ o.status }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Wallet -->
          <div class="dash-card mt-4" v-if="wallet.id">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <h6 class="fw-bold mb-1" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-wallet me-2"></i>Wallet Balance</h6>
                <div style="font-size:28px;font-weight:700;color:#BFA164;">KES {{ formatPrice(wallet.available_balance) }}</div>
                <div v-if="wallet.escrow_balance > 0" style="color:var(--fm-s,#6B6356);font-size:12px;">In escrow: KES {{ formatPrice(wallet.escrow_balance) }}</div>
              </div>
            </div>
          </div>

          <!-- Notifications -->
          <div class="dash-card mt-4" v-if="notifications.length > 0">
            <h6 class="fw-bold mb-3" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-bell me-2"></i>Recent Notifications</h6>
            <div v-for="(n,ni) in notifications.slice(0,5)" :key="'n-'+ni" class="dash-notif-item" :class="{unread:!n.is_read}">
              <div class="dash-notif-dot" v-if="!n.is_read"></div>
              <div class="flex-fill">
                <div style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ n.title }}</div>
                <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ n.message }}</div>
              </div>
              <div style="color:var(--fm-s,#6B6356);font-size:10px;white-space:nowrap;">{{ formatTimeAgo(n.created_at) }}</div>
            </div>
          </div>

          <!-- Mobile New Listing -->
          <div class="d-md-none text-center mt-4">
            <button class="btn btn-warning w-100" @click="$router.push('/sell/create')"><i class="mdi mdi-plus me-1"></i> New Listing</button>
          </div>
        </div>
      </div>

      <!-- WORKER EVIDENCE MODAL -->
      <div v-if="showWorkerEvidence" class="dash-overlay" @click.self="showWorkerEvidence=false"><div class="dash-evidence-modal">
        <h6 style="color:var(--fm-h,#F5F0E8);font-size:15px;"><i class="mdi mdi-check-decagram me-2" style="color:#50C878;"></i>Complete Task</h6>
        <div style="background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:10px;margin-bottom:12px;">
          <strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ workerEvidenceTask.title }}</strong>
          <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ workerEvidenceTask.farm_name }} · Due: {{ fDate(workerEvidenceTask.due_date) }}</div>
        </div>
        <div v-if="workerEvidenceTask.require_photo==='1'" class="mb-3">
          <label style="font-size:11px;font-weight:600;color:var(--fm-m,#A09888);display:block;margin-bottom:4px;"><i class="mdi mdi-camera me-1" style="color:#4FC3F7;"></i>Photo Evidence *</label>
          <div class="d-flex gap-2 mb-2">
            <button class="btn btn-sm btn-outline-info" @click="$refs.wEvidenceFile.click()"><i class="mdi mdi-image-plus me-1"></i>Gallery</button>
            <button class="btn btn-sm btn-outline-info" @click="openWorkerCamera()"><i class="mdi mdi-camera me-1"></i>Take Photo</button>
          </div>
          <input type="file" ref="wEvidenceFile" accept="image/*" multiple @change="handleWorkerEvidenceFiles" style="display:none;" />
          <div v-if="wEvidencePhotos.length" class="d-flex gap-2 flex-wrap">
            <div v-for="(p,pi) in wEvidencePhotos" :key="pi" style="position:relative;width:65px;height:65px;border-radius:8px;overflow:hidden;border:1px solid var(--fm-br,#2A2520);">
              <img :src="p.preview" style="width:100%;height:100%;object-fit:cover;" />
              <button class="btn btn-sm" style="position:absolute;top:1px;right:1px;background:rgba(0,0,0,.6);color:#FF6B6B;padding:0 3px;font-size:11px;border-radius:3px;" @click="wEvidencePhotos.splice(pi,1)"><i class="mdi mdi-close"></i></button>
              <div style="position:absolute;bottom:0;left:0;right:0;background:rgba(0,0,0,.7);color:var(--fm-s,#6B6356);font-size:8px;text-align:center;padding:1px;">{{ (p.size/1024).toFixed(0) }}KB</div>
            </div>
          </div>
        </div>
        <div v-if="workerEvidenceTask.require_gps==='1'" class="mb-3">
          <label style="font-size:11px;font-weight:600;color:var(--fm-m,#A09888);display:block;margin-bottom:4px;"><i class="mdi mdi-map-marker me-1" style="color:#FF6B6B;"></i>GPS Location *</label>
          <div v-if="wEvidenceGps.lat" style="background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#2A2520);border-radius:8px;padding:8px;display:flex;align-items:center;gap:8px;">
            <i class="mdi mdi-check-circle" style="color:#50C878;font-size:18px;"></i>
            <div><div style="color:var(--fm-h,#F5F0E8);font-size:11px;">{{ wEvidenceGps.lat.toFixed(6) }}, {{ wEvidenceGps.lng.toFixed(6) }}</div><div style="color:var(--fm-s,#6B6356);font-size:10px;">Accuracy: {{ wEvidenceGps.accuracy?wEvidenceGps.accuracy.toFixed(0)+'m':'—' }}</div></div>
            <button class="btn btn-sm btn-outline-warning ms-auto" @click="captureWorkerGps"><i class="mdi mdi-refresh"></i></button>
          </div>
          <button v-else class="btn btn-sm btn-outline-warning" @click="captureWorkerGps" :disabled="wCapturingGps">
            <span v-if="wCapturingGps"><span class="spinner-border spinner-border-sm me-1"></span>Getting location...</span>
            <span v-else><i class="mdi mdi-crosshairs-gps me-1"></i>Capture My Location</span>
          </button>
          <div v-if="wGpsError" style="color:#FF6B6B;font-size:11px;margin-top:3px;">{{ wGpsError }}</div>
        </div>
        <div v-if="workerEvidenceTask.require_notes==='1'" class="mb-3">
          <label style="font-size:11px;font-weight:600;color:var(--fm-m,#A09888);display:block;margin-bottom:4px;"><i class="mdi mdi-text me-1" style="color:#BFA164;"></i>Notes *</label>
          <textarea v-model="wEvidenceNotes" class="form-control form-control-sm" rows="3" style="background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8);" placeholder="What was done, observations..."></textarea>
        </div>
        <div v-if="workerEvidenceTask.require_notes!=='1'" class="mb-3">
          <label style="font-size:11px;font-weight:600;color:var(--fm-m,#A09888);display:block;margin-bottom:4px;">Notes (optional)</label>
          <input v-model="wEvidenceNotes" class="form-control form-control-sm" style="background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8);" placeholder="Any notes..." />
        </div>
        <button class="btn btn-success w-100" @click="submitWorkerEvidence" :disabled="!canSubmitWorkerEvidence||processing">
          <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Submitting...</span>
          <span v-else><i class="mdi mdi-check-decagram me-1"></i>Complete with Evidence</span>
        </button>
        <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="showWorkerEvidence=false">Cancel</button>
      </div></div>

    </div>

    <!-- Terms gate — auto-pops if user hasn't accepted current version -->
    <terms-gate />
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0F200F"]{background:#EDF7EF!important}
html[data-theme="light"] [style*="background:#200F0F"]{background:#FFF2F2!important}
html[data-theme="light"] [style*="background:#0F2030"]{background:#E8F4FD!important}
html[data-theme="light"] [style*="background:#2A2520"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}

html[data-theme="light"] .dash-root,html[data-theme="light"] .dash-root #layout-wrapper{background:#F7F5F2!important;color:#1A1A1A!important;}
html[data-theme="light"] .dash-topbar{background:rgba(247,245,242,.96)!important;border-bottom-color:#E8E2DA!important;}
html[data-theme="light"] .dash-user-menu{background:rgba(0,0,0,.08)!important;}
</style>
<style scoped>
.dash-root,.dash-root #layout-wrapper{background:var(--fm-bg2,#0F0F0F)!important;min-height:100vh;color:var(--fm-h,#F5F0E8)!important}
.dash-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg2,#0F0F0F)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
html[data-theme="light"] .dash-root,html[data-theme="light"] .dash-root #layout-wrapper{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .dash-topbar{background:rgba(247,245,242,.96)!important}
html[data-theme="light"] .dash-evidence-modal{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .dash-stat-card,html[data-theme="light"] .dash-quick-card,html[data-theme="light"] .dash-card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .dash-stat-card:hover{border-color:#D9D0C5!important}
html[data-theme="light"] .dash-quick-card:hover{border-color:#BFA164!important}
html[data-theme="light"] .dash-menu-card{background:#FFFFFF!important;border-color:#E8E2DA!important;box-shadow:0 8px 24px rgba(0,0,0,.1)!important}
html[data-theme="light"] .dash-menu-item:hover{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .dash-list-item{border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .dash-list-thumb{background:#F0EBE4!important}
html[data-theme="light"] .dash-icon-btn{background:rgba(191,161,100,0.08)!important;border-color:#E8E2DA!important}
html[data-theme="light"] .dash-notif-item{border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .dash-notif-item.unread{background:rgba(191,161,100,.06)!important}
.dash-container{padding-top:80px;padding-bottom:80px;max-width:1100px}

.dash-icon-btn{position:relative;cursor:pointer;color:var(--fm-s,#6B6356);transition:color .2s;width:36px;height:36px;display:flex;align-items:center;justify-content:center;border-radius:50%;background:rgba(191,161,100,0.06);border:1px solid var(--fm-br,#1E1E1E)}
.dash-icon-btn:hover{color:#BFA164;border-color:#BFA164;background:rgba(191,161,100,0.1)}
.dash-notif-badge{position:absolute;top:-4px;right:-4px;background:#FF6B6B!important;color:#fff!important;font-size:9px;font-weight:700;border-radius:10px;padding:1px 5px;min-width:16px;text-align:center}
.dash-user-btn{cursor:pointer}
.dash-avatar-sm{width:32px;height:32px;border-radius:50%;background:var(--fm-bg3,#1E1E1E)!important;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;color:#BFA164!important}
.dash-avatar-md{width:40px;height:40px;border-radius:50%;background:var(--fm-bg3,#1E1E1E)!important;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:#BFA164!important}
.dash-avatar-xs{width:30px;height:30px;border-radius:50%;background:var(--fm-bg3,#1E1E1E)!important;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;color:#BFA164!important;flex-shrink:0}

/* User Menu */
.dash-user-menu{position:fixed;top:0;left:0;right:0;bottom:0;z-index:150;background:rgba(0,0,0,.3)!important}
.dash-menu-card{position:absolute;top:58px;right:20px;background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:16px;width:240px;box-shadow:0 8px 24px rgba(0,0,0,.5)}
.dash-menu-item{display:flex;align-items:center;padding:8px;border-radius:6px;color:var(--fm-m,#A09888)!important;font-size:13px;text-decoration:none;transition:all .15s}
.dash-menu-item:hover{background:var(--fm-bg3,#1E1E1E)!important;color:var(--fm-h,#F5F0E8)!important}

/* Welcome */
.dash-welcome{display:flex;align-items:center;justify-content:space-between}

/* Stats */
.dash-stat-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px;text-align:center;transition:all .2s}
.dash-stat-card:hover{border-color:var(--fm-br,#2A2520)}
.dash-stat-val{font-size:22px;font-weight:700;color:var(--fm-h,#F5F0E8)!important;margin-top:6px}
.dash-stat-lbl{font-size:11px;color:var(--fm-s,#6B6356)!important;margin-top:2px}

/* Quick Actions */
.dash-quick-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px;text-align:center;cursor:pointer;transition:all .2s}
.dash-quick-card:hover{border-color:#BFA164;transform:translateY(-2px)}
.dash-quick-label{font-size:12px;color:var(--fm-m,#A09888)!important;margin-top:6px}

/* Cards */
.dash-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:20px}

/* List Items */
.dash-list-item{display:flex;align-items:center;gap:10px;padding:10px 0;border-bottom:1px solid var(--fm-br,#1A1A1A);cursor:pointer}
.dash-list-item:last-child{border-bottom:none}
.dash-list-item:hover{opacity:.85}
.dash-list-thumb{width:36px;height:36px;border-radius:6px;overflow:hidden;background:var(--fm-bg2,#0F0F0F)!important;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.dash-list-thumb img{width:100%;height:100%;object-fit:cover}

/* Status */
.dash-status-dot{padding:2px 8px;border-radius:10px;font-size:10px;font-weight:600;text-transform:capitalize}
.st-active{background:rgba(80,200,120,.12)!important;color:#50C878!important}
.st-paused{background:rgba(241,180,76,.12)!important;color:#f1b44c!important}
.st-pending{background:rgba(241,180,76,.12)!important;color:#f1b44c!important}
.st-accepted{background:rgba(80,200,120,.12)!important;color:#50C878!important}
.st-rejected{background:rgba(255,107,107,.12)!important;color:#FF6B6B!important}
.st-countered{background:rgba(108,180,238,.12)!important;color:#6CB4EE!important}
.st-sold{background:rgba(108,180,238,.12)!important;color:#6CB4EE!important}
.st-draft{background:rgba(107,99,86,.2)!important;color:var(--fm-m,#A09888)!important}

/* Notifications */
.dash-notif-item{display:flex;align-items:start;gap:10px;padding:10px 0;border-bottom:1px solid var(--fm-br,#1A1A1A)}
.dash-notif-item:last-child{border-bottom:none}
.dash-notif-item.unread{background:rgba(191,161,100,.03)!important;margin:0 -8px;padding:10px 8px;border-radius:6px}
.dash-notif-dot{width:8px;height:8px;border-radius:50%;background:#BFA164!important;margin-top:4px;flex-shrink:0}

@media(max-width:768px){.dash-container{padding-top:70px}.dash-welcome{flex-direction:column;align-items:flex-start;gap:12px}}
.dash-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.7);z-index:200;display:flex;align-items:center;justify-content:center;padding:16px}
.dash-evidence-modal{background:#1A1A1A;border:1px solid var(--fm-br,#2A2520);border-radius:14px;padding:20px;width:100%;max-width:440px;max-height:90vh;overflow-y:auto}
</style>
<script>
/* eslint-disable */
import { execute, executeJson, flocker, uploads } from "@/api";
import UserAvatar from "@/components/flockr-users/UserAvatar.vue";
import TermsGate from "@/components/flockr-legal/TermsGate.vue";
export default {
  name: "Dashboard",
  components: { UserAvatar, TermsGate },
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',

    loading:true,showUserMenu:false,processing:false,
    cartCount: Number(sessionStorage.getItem('flockr_cart_count') || 0),
    user:{},wallet:{},isVet:false,
    recentListings:[],recentOffers:[],notifications:[],
    unreadCount:0,
    workerFarms:[],workerTasks:[],workerCompleted:[],workerStats:{pendingTasks:0,overdueTasks:0,completedThisWeek:0},
    showWorkerEvidence:false,workerEvidenceTask:{},wEvidencePhotos:[],wEvidenceGps:{lat:null,lng:null,accuracy:null},wEvidenceNotes:'',wCapturingGps:false,wGpsError:''
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},

    userInitials(){var n=this.user.display_name||sessionStorage.getItem('userName')||'';if(!n)return'?';return n.split(' ').map(function(w){return w[0]}).join('').substring(0,2).toUpperCase()},
    isAdmin(){
      // Check the role list stored at login time. Server-side assertAdmin() is the real defence.
      try {
        var roles = JSON.parse(sessionStorage.getItem('userRoles') || '[]');
        if (roles.indexOf('admin') > -1 || roles.indexOf('super_admin') > -1) return true;
      } catch(e) {}
      return this.user.role_type==='admin'||sessionStorage.getItem('userRole')==='admin';
    },
    greeting(){var h=new Date().getHours();if(h<12)return'Good morning';if(h<17)return'Good afternoon';return'Good evening'},
    firstName(){
      var n=this.user.first_name||'';
      if(!n){var dn=this.user.display_name||sessionStorage.getItem('userName')||'';n=dn.split(' ')[0]||''}
      return n||'there';
    },
    statsCards(){
      var active=this.recentListings.filter(function(l){return l.status==='active'}).length;
      var pending=this.recentOffers.filter(function(o){return o.status==='pending'}).length;
      return[
        {label:'Active Listings',value:active,icon:'mdi mdi-tag-multiple',color:'#50C878',route:'/my-listings'},
        {label:'Pending Offers',value:pending,icon:'mdi mdi-handshake',color:'#f1b44c',route:'/my-offers'},
        {label:'Wallet',value:'KES '+this.formatPrice(this.wallet.available_balance||0),icon:'mdi mdi-wallet',color:'#BFA164',route:null},
        {label:'Notifications',value:this.unreadCount,icon:'mdi mdi-bell',color:'#6CB4EE',route:null}
      ]
    },
    quickActions(){return[
      {label:'My Orders',icon:'mdi mdi-receipt',route:'/orders'},
      {label:'My Sales',icon:'mdi mdi-tag-multiple',route:'/orders?role=seller'},
      {label:'My Farm',icon:'mdi mdi-barn',route:'/farm'},
      {label:'Escrow',icon:'mdi mdi-shield-lock',route:'/escrow'},
      {label:'Wallet',icon:'mdi mdi-wallet',route:'/wallet'},
      {label:'Messages',icon:'mdi mdi-message-text',route:'/messages'},
      {label:'Notifications',icon:'mdi mdi-bell',route:'/notifications'},
      {label:'New Listing',icon:'mdi mdi-plus-circle',route:'/sell/create'},
      {label:'Browse Market',icon:'mdi mdi-storefront',route:'/marketplace'},
      {label:'Buy Requests',icon:'mdi mdi-bullhorn',route:'/marketplace/buy-requests'},
      {label:'Find a Vet',icon:'mdi mdi-stethoscope',route:'/vets'},
      {label:'Saved',icon:'mdi mdi-heart',route:'/marketplace/saved'},
      {label:'Get Verified',icon:'mdi mdi-shield-check',route:'/verification'}
    ]},
    canSubmitWorkerEvidence(){
      var t=this.workerEvidenceTask;
      if(t.require_photo==='1'&&this.wEvidencePhotos.length===0)return false;
      if(t.require_gps==='1'&&!this.wEvidenceGps.lat)return false;
      if(t.require_notes==='1'&&!this.wEvidenceNotes.trim())return false;
      return true;
    }
  },
  mounted(){
    // Apply global theme
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);

    var u=sessionStorage.getItem('userId');
    if(!u){this.$router.push('/login');return}
    this.loadDashboard();
    this.startPresenceHeartbeat();
    this.loadCartCount();
    var self=this;
    this._onCartUpdated=function(e){if(e&&e.detail)self.cartCount=Number(e.detail.count||0);};
    window.addEventListener('flockr-cart-updated', this._onCartUpdated);
    // Refresh notification badge when something marks notifications read elsewhere
    this._onNotifChanged=function(){var u=sessionStorage.getItem('userId');if(u)self.fetchNotifications(u);};
    window.addEventListener('flockr-notifications-changed', this._onNotifChanged);
    // Also refresh when the user returns to the tab/page (after marking on /notifications)
    this._onFocus=function(){var u=sessionStorage.getItem('userId');if(u)self.fetchNotifications(u);};
    window.addEventListener('focus', this._onFocus);
    // Refresh user data (name + avatar) when MyProfile saves
    this._onProfileUpdated=function(e){
      if (e && e.detail) {
        if (e.detail.avatar_url !== undefined) self.user.avatar_url = e.detail.avatar_url;
        if (e.detail.display_name) self.user.display_name = e.detail.display_name;
      }
    };
    window.addEventListener('flockr-profile-updated', this._onProfileUpdated);
  },
  beforeUnmount(){
    this.stopPresenceHeartbeat();
    if(this._onCartUpdated) window.removeEventListener('flockr-cart-updated', this._onCartUpdated);
    if(this._onNotifChanged) window.removeEventListener('flockr-notifications-changed', this._onNotifChanged);
    if(this._onFocus) window.removeEventListener('focus', this._onFocus);
    if(this._onProfileUpdated) window.removeEventListener('flockr-profile-updated', this._onProfileUpdated);
  },
  methods:{
    photoUrl(p){if(!p)return'';if(p.startsWith&&p.startsWith('http'))return p;return uploads+String(p).replace('uploads/','')},

    async loadCartCount(){
      var userId=sessionStorage.getItem('userId');if(!userId)return;
      try{
        var f=new FormData();f.append('function','getCartCount');f.append('userId',userId);
        var r=await execute(f,flocker);
        if(r.data&&r.data.success&&r.data.data){
          this.cartCount=Number(r.data.data.cartCount||0);
          sessionStorage.setItem('flockr_cart_count',this.cartCount);
        }
      }catch(e){}
    },
    async loadDashboard(){
      this.loading=true;
      var userId=sessionStorage.getItem('userId');
      await Promise.all([
        this.fetchProfile(userId),
        this.fetchListings(userId),
        this.fetchOffers(userId),
        this.fetchWallet(userId),
        this.fetchNotifications(userId),
        this.fetchWorkerDashboard(userId),
        this.checkVetStatus(userId)
      ]);
      this.loading=false
    },
    startPresenceHeartbeat(){
      var self=this;
      this._sendPresence();
      this._presenceTimer=setInterval(function(){self._sendPresence()},120000);
      window.addEventListener('beforeunload',this._onUnload=function(){
        var userId=sessionStorage.getItem('userId');if(!userId)return;
        var f=new FormData();f.append('function','setOffline');f.append('userId',userId);
        navigator.sendBeacon?navigator.sendBeacon(flocker,f):null;
      });
      document.addEventListener('visibilitychange',this._onVisChange=function(){
        if(document.hidden){self._onUnload();}else{self._sendPresence();}
      });
    },
    stopPresenceHeartbeat(){
      if(this._presenceTimer)clearInterval(this._presenceTimer);
      if(this._onUnload)window.removeEventListener('beforeunload',this._onUnload);
      if(this._onVisChange)document.removeEventListener('visibilitychange',this._onVisChange);
    },
    async _sendPresence(){
      var userId=sessionStorage.getItem('userId');if(!userId)return;
      try{var f=new FormData();f.append('function','updatePresence');f.append('userId',userId);await execute(f,flocker);}catch(e){}
    },
    async fetchProfile(userId){
      try{var r=await executeJson({function:"getUserProfile",userId:userId},flocker);if(r.data.success)this.user=r.data.data.user||{}}catch(e){console.error(e)}
    },
    async fetchListings(userId){
      try{var r=await executeJson({function:"getMyListings",sellerId:userId},flocker);if(r.data.success)this.recentListings=r.data.data.listings||[]}catch(e){console.error(e)}
    },
    async fetchOffers(userId){
      try{var r=await executeJson({function:"getListingOffers",sellerId:userId},flocker);if(r.data.success)this.recentOffers=r.data.data.offers||[]}catch(e){console.error(e)}
    },
    async fetchWallet(userId){
      try{var r=await executeJson({function:"getWalletBalance",userId:userId},flocker);if(r.data.success)this.wallet=r.data.data.wallet||{}}catch(e){console.error(e)}
    },
    async fetchNotifications(userId){
      try{var r=await executeJson({function:"getNotifications",userId:userId,limit:5},flocker);if(r.data.success){this.notifications=r.data.data.notifications||[];this.unreadCount=r.data.data.unread||0}}catch(e){console.error(e)}
    },
    async logout(){
      var userId=sessionStorage.getItem('userId');
      try{await executeJson({function:"logoutUser",userId:userId},flocker)}catch(e){console.error(e)}
      sessionStorage.clear();
      localStorage.removeItem('authToken');
      this.$router.push('/login')
    },
    formatPrice(a){return a?Number(a).toLocaleString('en-KE'):'0'},
    formatTimeAgo(d){
      if(!d)return'';
      var now=new Date();var then=new Date(d);var diff=Math.floor((now-then)/(1000*60));
      if(diff<1)return'Just now';if(diff<60)return diff+'m ago';
      if(diff<1440)return Math.floor(diff/60)+'h ago';
      return Math.floor(diff/1440)+'d ago'
    },
    getInitials(n){if(!n)return'?';return n.split(' ').map(function(w){return w[0]}).join('').substring(0,2).toUpperCase()},
    fDate(d){if(!d)return'—';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'numeric'})},
    formatTime(t){if(!t)return'';var parts=t.split(':');var h=parseInt(parts[0]);var m=parts[1]||'00';var ampm=h>=12?'PM':'AM';h=h%12||12;return h+':'+m+' '+ampm},

    // Worker Dashboard
    async fetchWorkerDashboard(userId){
      try{
        var r=await executeJson({function:'getWorkerDashboard',userId:userId},flocker);
        if(r.data&&r.data.success){
          this.workerFarms=r.data.data.farms||[];
          this.workerTasks=r.data.data.tasks||[];
          this.workerCompleted=r.data.data.completed||[];
          this.workerStats=r.data.data.stats||{pendingTasks:0,overdueTasks:0,completedThisWeek:0};
        }
      }catch(e){}
    },
    async checkVetStatus(userId){
      try{
        var r=await executeJson({function:'getVetProfile',vetUserId:userId},flocker);
        this.isVet=!!(r.data&&r.data.success&&r.data.data&&r.data.data.vet&&r.data.data.vet.user_id);
      }catch(e){this.isVet=false}
    },
    workerTaskNeedsEvidence(t){return t.require_photo==='1'||t.require_gps==='1'||t.require_notes==='1'},
    async workerStartTask(t){
      this.processing=true;
      try{var r=await executeJson({function:'updateFarmTask',taskId:t.id,status:'in_progress',updatedBy:sessionStorage.getItem('userId')},flocker);
        if(r.data&&r.data.success)await this.fetchWorkerDashboard(sessionStorage.getItem('userId'));else alert(r.data.message||'Failed')
      }catch(e){alert('Error')}this.processing=false;
    },
    async workerCompleteTask(t){
      this.processing=true;
      try{var r=await executeJson({function:'updateFarmTask',taskId:t.id,status:'completed',updatedBy:sessionStorage.getItem('userId')},flocker);
        if(r.data&&r.data.success){await this.fetchWorkerDashboard(sessionStorage.getItem('userId'));alert('Task completed!')}else alert(r.data.message||'Failed')
      }catch(e){alert('Error')}this.processing=false;
    },
    workerCompleteWithEvidence(t){
      this.workerEvidenceTask=t;this.wEvidencePhotos=[];this.wEvidenceGps={lat:null,lng:null,accuracy:null};this.wEvidenceNotes='';this.wGpsError='';
      this.showWorkerEvidence=true;
      if(t.require_gps==='1')this.captureWorkerGps();
    },
    handleWorkerEvidenceFiles(e){
      var files=e.target.files;var self=this;
      for(var i=0;i<files.length;i++){
        (function(file){
          var reader=new FileReader();
          reader.onload=function(ev){
            var img=new Image();
            img.onload=function(){
              var canvas=document.createElement('canvas');
              var maxW=1200;var w=img.width;var h=img.height;
              if(w>maxW){h=h*(maxW/w);w=maxW}
              canvas.width=w;canvas.height=h;
              var ctx=canvas.getContext('2d');ctx.drawImage(img,0,0,w,h);
              // First pass at 0.8
              canvas.toBlob(function(blob){
                // If still > 500KB, second pass at 0.6
                if(blob.size>500000){
                  canvas.toBlob(function(blob2){
                    var final=blob2||blob;
                    self.wEvidencePhotos.push({file:final,preview:URL.createObjectURL(final),size:final.size});
                  },'image/jpeg',0.6);
                }else{
                  self.wEvidencePhotos.push({file:blob,preview:URL.createObjectURL(blob),size:blob.size});
                }
              },'image/jpeg',0.8);
            };
            img.src=ev.target.result;
          };
          reader.readAsDataURL(file);
        })(files[i]);
      }
      e.target.value='';
    },
    openWorkerCamera(){
      var input=document.createElement('input');
      input.type='file';input.accept='image/*';input.capture='environment';
      var self=this;
      input.onchange=function(e){self.handleWorkerEvidenceFiles(e)};
      input.click();
    },
    captureWorkerGps(){
      this.wCapturingGps=true;this.wGpsError='';
      var self=this;
      if(!navigator.geolocation){this.wGpsError='GPS not available';this.wCapturingGps=false;return}
      navigator.geolocation.getCurrentPosition(
          function(pos){self.wEvidenceGps={lat:pos.coords.latitude,lng:pos.coords.longitude,accuracy:pos.coords.accuracy};self.wCapturingGps=false},
          function(err){self.wGpsError=err.code===1?'Location permission denied':err.code===2?'Location unavailable':'GPS timeout — try again';self.wCapturingGps=false},
          {enableHighAccuracy:true,timeout:15000,maximumAge:0}
      );
    },
    async submitWorkerEvidence(){
      this.processing=true;
      try{
        var f=new FormData();
        f.append('function','completeTaskWithEvidence');
        f.append('taskId',this.workerEvidenceTask.id);
        f.append('completedBy',sessionStorage.getItem('userId'));
        if(this.wEvidenceNotes)f.append('evidenceNotes',this.wEvidenceNotes);
        if(this.wEvidenceGps.lat){
          f.append('gpsLat',this.wEvidenceGps.lat);
          f.append('gpsLng',this.wEvidenceGps.lng);
          f.append('gpsAccuracy',this.wEvidenceGps.accuracy||'');
        }
        for(var i=0;i<this.wEvidencePhotos.length;i++){
          f.append('evidence_photo_'+i,this.wEvidencePhotos[i].file,'evidence_'+Date.now()+'_'+i+'.jpg');
        }
        f.append('photoCount',this.wEvidencePhotos.length);
        var r=await execute(f,flocker);
        if(r.data&&r.data.success){
          this.showWorkerEvidence=false;
          await this.fetchWorkerDashboard(sessionStorage.getItem('userId'));
          alert('Task completed with evidence!');
        }else alert((r.data&&r.data.message)||'Failed')
      }catch(e){alert('Error submitting evidence')}
      this.processing=false;
    }
  }
};
</script>